import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environments';
import { UserActiveSubscriptionsResponse } from '../models/subscription';

@Injectable({
  providedIn: 'root'
})
export class SubscriptionPlansService {
  private BASE_URL = environment.apiUrl + 'api';

  constructor(private http: HttpClient) { }

  getSubscriptionPlans(): Observable<any> {
    const url = `${this.BASE_URL}/subscription_plans/all`;
    return this.http.get<any>(url);
  }

  subscribeToPlan(planId: string, userId: string): Observable<any> {
    const url = `${this.BASE_URL}/subscription_plans/subscribe`;
    return this.http.post<any>(url, { plan_id: parseInt(planId), user_id: parseInt(userId) });
  }

  getUserDaysLeft(userId: string): Observable<any> {
    const url = `${this.BASE_URL}/subscription_plans/${userId}/subscription-days-left`;
    return this.http.get<any>(url);
  }

  getUserActiveSubscriptions(userId: string): Observable<UserActiveSubscriptionsResponse> {
    const url = `${this.BASE_URL}/subscription_plans/${userId}/active-subscriptions`;
    return this.http.get<UserActiveSubscriptionsResponse>(url);
  }

}